import { render, staticRenderFns } from "./formLikert.vue?vue&type=template&id=1bbaeb15&scoped=true&"
import script from "./formLikert.vue?vue&type=script&lang=js&"
export * from "./formLikert.vue?vue&type=script&lang=js&"
import style0 from "./formLikert.vue?vue&type=style&index=0&id=1bbaeb15&lang=scss&scoped=true&"
import style1 from "./formLikert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbaeb15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBadge,VBtn,VCheckbox,VDialog,VDivider,VIcon,VSwitch,VTextField,VTextarea,VTreeview})
